module.exports = __webpack_public_path__ + "img/6.bb4b2373.jpg";